import { formulaIcon } from "../../assets/image/icon/svg-icon.ts";
class MyKityFormulaMenu {
  constructor() {
    this.title = '插入公式'
    this.iconSvg = formulaIcon
    this.tag = 'button'
  }
  getValue(editor) {
    return 'listen'
  }
  isActive(editor) {
    return false // or true
  }
  isDisabled(editor) {
    return false // or true
  }
  exec(editor, value) {
    // handleOpen(editor);
    // editor.insertText(value) // value 即 this.getValue(editor) 的返回值
  }
}

const menuConf = {
  key: "kityFormula", // menu key ，唯一。注册之后，需通过 toolbarKeys 配置到工具栏
  factory() {
    return new MyKityFormulaMenu();
  },
};

export default menuConf;
